export default __webpack_public_path__ + "static/media/all-top-corners-rounded-3.07423218.webp";